/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagSection } from '../../models/tag-section';

export interface DocumentGetTagList$Params {

/**
 * GUID of the document
 */
  documentId: string;
}

export function documentGetTagList(http: HttpClient, rootUrl: string, params: DocumentGetTagList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TagSection>>> {
  const rb = new RequestBuilder(rootUrl, documentGetTagList.PATH, 'get');
  if (params) {
    rb.path('documentId', params.documentId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TagSection>>;
    })
  );
}

documentGetTagList.PATH = '/document/{documentId}/tag/list';
